import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { autobind } from 'core-decorators';
import { DownloadArquivoSistema } from 'src/services/downloadFileUrl';
import List from 'src/componentes/list';
import ListColumn from 'src/componentes/list/list-column';
import CargoEdit from './edit';
import ContentManager from 'src/componentes/content-manager';
import ValidacaoRestricao from 'src/paginas/item/validacao-restricao';
import http from 'src/services/httpService';
import { MODULOS } from 'src/utils/constants';
import Search from './search';
import SearchSchema from './search-schema';
import { FILTROS } from 'src/utils/constants';
import LucideIcon from 'src/componentes/lucide-icon';

@autobind
class Cargo extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      saved: false,
      contratoResultadosVinculadoCargo: false,
      componentKey: 1,
    };
  }

  afterRemove = () => {
    this.setState({ saved: true });
  };

  handleDeleteClick = (item) => {
    ContentManager.addContent(
      <ValidacaoRestricao
        url="/Cargo/ValidarRestricoes"
        urlExclusao="/Cargo/Remove"
        item={item}
        afterRemove={this.afterRemove}
        //urlList="/CausaRisco"
        urlEdit="/Cargo/edit"
        isEdit={true}
      />
    );
  };

  componentDidMount() {
    http
      .post(`/CardMeta/ObterConfiguracaoContratoResultados`, {})
      .then((response) => {
        this.setState((prevState) => ({
          contratoResultadosVinculadoCargo:
            response.data.contratoResultadosVinculadoCargo,
          componentKey: prevState.componentKey + 1,
        }));
      });
  }

  renderNome(item) {
    const handleEdit = () => {
      ContentManager.addContent(
        <CargoEdit
          handleClose={(saved) => {
            saved &&
              this.setState({
                saved: !this.state.saved,
              });
          }}
          item={item}
          showDelete={true}
        />
      );
    };

    return (
      <a
        className="font-weight-bold text-primary cursor-pointer"
        onClick={() => handleEdit(item)}
      >
        {item.nome}
      </a>
    );
  }

  renderCriticidade(item) {
    return <span>{item.criticidade && item.criticidade.nome}</span>;
  }

  renderTipo(item) {
    return <span>{item.tipoCargo && item.tipoCargo.nome}</span>;
  }

  renderModeloBonificacao(item) {
    const { intl } = this.props;
    return (
      <span
        title={intl.formatMessage({ id: 'label.download' })}
        style={{ marginRight: '8px' }}
      >
        {item.modeloBonificacaoGuid ? (
          <LucideIcon
            icon="Download"
            className="cursor-pointer"
            size={20}
            onClick={(event) => {
              event.stopPropagation();
              DownloadArquivoSistema(item.modeloBonificacaoGuid);
            }}
          />
        ) : (
          ''
        )}
      </span>
    );
  }

  render() {
    let { intl, modulosComprados } = this.props;
    let { contratoResultadosVinculadoCargo, componentKey } = this.state;

    let hasRV = modulosComprados.find(
      (m) => m.id === MODULOS.REMUNERACAO_VARIAVEL && m.ativo
    );

    return (
      <List
        key={`list-${componentKey}`}
        url="/Cargo"
        editComponent={CargoEdit}
        sort="Nome"
        showSearch={true}
        saved={this.state.saved}
        {...this.props}
        tag={11002}
        onDeleting={this.handleDeleteClick}
        searchComponent={<Search />}
        searchSchema={SearchSchema}
        filtroId={FILTROS.CARGOS}
        filterDrawer
      >
        <ListColumn
          headerText={intl.formatMessage({ id: 'nome' })}
          valueField="nome"
          valueFunction={this.renderNome}
          required
          default
        />
        <ListColumn
          headerText={intl.formatMessage({ id: 'tipo' })}
          valueFunction={this.renderTipo}
          valueField="tipoCargo"
          default
        />
        <ListColumn
          headerText={intl.formatMessage({ id: 'descricao' })}
          valueField="descricao"
          default
        />
        <ListColumn
          headerText={intl.formatMessage({ id: 'idIntegracao' })}
          valueField="idIntegracao"
          sortField="idIntegracao"
        />
        <ListColumn
          headerText={intl.formatMessage({ id: 'criticidade' })}
          valueFunction={this.renderCriticidade}
          valueField="criticidade"
          sortField="criticidade.Nome"
        />
        <ListColumn
          headerText={intl.formatMessage({ id: 'modeloBonificacao' })}
          valueFunction={this.renderModeloBonificacao}
          valueField="modeloBonificacaoGuid"
          visible={hasRV && contratoResultadosVinculadoCargo}
          center
        />
      </List>
    );
  }
}

function mapStateToProps(state) {
  return {
    resources: state.user.termos,
    modulosComprados: state.user.licenca.modulos,
  };
}
export default injectIntl(connect(mapStateToProps)(Cargo));
